import React from 'react';

const Header = ({ language, onLanguageChange }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy/95 backdrop-blur-sm shadow-lg">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-2xl md:text-3xl font-bold text-white">
          Charlotte Dipanda
        </h1>
        
        <div className="flex items-center gap-2">
          <button
            onClick={() => onLanguageChange('fr')}
            className={`px-4 py-2 rounded-lg font-semibold transition-all duration-300 ${
              language === 'fr'
                ? 'bg-white text-navy'
                : 'bg-transparent text-white hover:bg-white/10'
            }`}
          >
            FR
          </button>
          <button
            onClick={() => onLanguageChange('en')}
            className={`px-4 py-2 rounded-lg font-semibold transition-all duration-300 ${
              language === 'en'
                ? 'bg-white text-navy'
                : 'bg-transparent text-white hover:bg-white/10'
            }`}
          >
            EN
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
